import { AutoAwesome } from '@mui/icons-material';
import { AvatarProps, Avatar, useTheme, Box, styled, alpha, Stack, Typography } from '@mui/material';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import { User } from 'react-feather';
import IconFeather from 'src/components/common/Icon';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';

interface IProps extends AvatarProps {
  alt?: string;
  colorIcon?: string;
}
const PulsingBox = styled(Stack)(({ theme }) => ({
  '@keyframes pulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.5 },
  },
  animation: 'pulse 3s infinite ease-in-out',
}));

const BouncyBox = styled(Box)(({ theme }) => ({
  // Define your bounce keyframes
  '@keyframes bounce': {
    '0%, 20%, 50%, 80%, 100%': {
      transform: 'translateY(0)',
    },
    '40%': {
      transform: 'translateY(-10px)',
    },
    '60%': {
      transform: 'translateY(-5px)',
    },
  },
  animation: 'bounce 2s infinite',
}));

const AISummaryLoading = ({ alt, colorIcon, sizes, variant, src, ...props }: IProps) => {
  const theme = useTheme();

  return (
    <WhiteBoxContent
      sx={{
        background: `linear-gradient(90deg, ${alpha(theme.palette.primary.light, 0.2)} 0%,${alpha(theme.palette.primary.light, 0.1)} 100%)`,
      }}
      border={`1px solid ${theme.palette.primary.light}`}
    >
      <Stack alignItems="center" direction="row" gap={3} mb={4}>
        <PulsingBox
          width={theme.spacing(4)}
          height={theme.spacing(4)}
          borderRadius={theme.shape.borderRadius / 2}
          bgcolor={theme.palette.primary.main}
          justifyContent="center"
          alignItems="center"
        >
          <AutoAwesome sx={{ color: theme.palette.background.paper }} />
        </PulsingBox>
        <Typography color="text.primary" variant="h5">
          AI Summary
        </Typography>
      </Stack>

      <Stack direction="column" gap={2}>
        <Stack direction="column" spacing={2} justifyContent="center" alignItems={'center'}>
          <Typography variant="body1">Analyzing Data</Typography>
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
            <BouncyBox
              width={5}
              height={5}
              bgcolor={'primary.main'}
              borderRadius={'50%'}
              sx={{ animationDelay: '0ms' }}
            />
            <BouncyBox
              width={5}
              height={5}
              bgcolor={'primary.main'}
              borderRadius={'50%'}
              sx={{ animationDelay: '150ms' }}
            />
            <BouncyBox
              width={5}
              height={5}
              bgcolor={'primary.main'}
              borderRadius={'50%'}
              sx={{ animationDelay: '300ms' }}
            />
          </Stack>
        </Stack>

        {/* <div className="space-y-4">
          <div className="flex gap-3">
            <div className="flex-shrink-0 mt-1">
              <div className="size-5 bg-indigo-200 rounded animate-pulse"></div>
            </div>
            <div className="flex-1 space-y-3">
              <div className="h-5 bg-indigo-200 rounded w-32 animate-pulse"></div>
              {[1, 2, 3].map((i) => (
                <div key={i} className="bg-white/50 rounded-lg p-3 border border-indigo-100 space-y-2">
                  <div className="h-6 bg-indigo-200 rounded w-12 animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex gap-3">
            <div className="flex-shrink-0 mt-1">
              <div className="size-5 bg-amber-200 rounded animate-pulse"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="h-5 bg-amber-200 rounded w-40 animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse"></div>
            </div>
          </div>

          <div className="flex gap-3">
            <div className="flex-shrink-0 mt-1">
              <div className="size-5 bg-purple-200 rounded animate-pulse"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="h-5 bg-purple-200 rounded w-36 animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse"></div>
            </div>
          </div>

          <div className="flex gap-3">
            <div className="flex-shrink-0 mt-1">
              <div className="size-5 bg-green-200 rounded animate-pulse"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="h-5 bg-green-200 rounded w-44 animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded w-4/5 animate-pulse"></div>
            </div>
          </div>
        </div> */}
      </Stack>
    </WhiteBoxContent>
  );
};

export default AISummaryLoading;
